<template>
  <el-row type="flex" justify="space-between">
    <el-col :span="13">
      <el-input-number
        v-model="base"
        controls-position="right"
        :step="1"
        :step-strictly="true"
        @change="changeBase"
        style="width: 100%;"
      >
      </el-input-number>
    </el-col>
    <el-col :span="10">
      <el-select
        v-model="unit"
        @change="changeUnit"
        style="width: 100%;"
      >
        <el-option
          v-for="unit in units"
          :key="unit.label"
          :label="unit.label"
          :value="unit.value"
        >
        </el-option>
      </el-select>
    </el-col>
  </el-row>
</template>

<script>
export default {
  model: {
    prop: 'interval',
    event: 'change',
  },
  props: {
    interval: {
      type: Number,
      default: 0,
    },
    units: {
      type: Array,
      default() {
        return [
          { label: this.$t('units.hour'), value: 3600 * 1000 },
          { label: this.$t('units.minute'), value: 60 * 1000 },
          { label: this.$t('units.second'), value: 1000 },
        ];
      },
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
  },
  data() {
    return {
      base: 0,
      unit: 0,
    };
  },
  created() {
    this.divideInterval(this.interval);
  },
  watch: {
    interval(interval) {
      this.divideInterval(interval);
    },
  },
  methods: {
    divideInterval(interval) {
      let unit = 1;
      let base = 1;
      const sortedUnits = this.units.sort((a, b) => {
        return b.value - a.value;
      });
      for (let i = 0; i < sortedUnits.length; i += 1) {
        unit = sortedUnits[i].value;
        base = interval / unit;
        if (base >= 1 && base === +base.toFixed()) break;
        base = 1;
      }
      this.base = base;
      this.unit = unit;
    },
    changeBase(base) {
      this.emitChange(base, this.unit);
    },
    changeUnit(unit) {
      this.emitChange(this.base, unit);
    },
    emitChange(base, unit) {
      const value = base * unit;
      if (this.max !== undefined && value >= this.max) {
        this.$nextTick(() => {
          this.divideInterval(this.max);
          this.$emit('change', this.max);
        });
        return;
      }
      if (this.min !== undefined && value <= this.min) {
        this.$nextTick(() => {
          this.divideInterval(this.min);
          this.$emit('change', this.min);
        });
        return;
      }
      this.$emit('change', value);
    },
  },
};
</script>
